import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=0084dd32&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=ts&"
export * from "./Loading.vue?vue&type=script&lang=ts&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=0084dd32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084dd32",
  null
  
)

export default component.exports